import { ArticlePageContextValue } from "contexts/new/ArticlePageContext";
import { trackEvent } from "services/frontend/Segment";
import { baseUrl } from "services/shared/Environment";
import {
  SegmentClientEvent,
  getSegmentEventIDForSubscriber,
} from "services/shared/SegmentEvents";
import Cookies from "js-cookie";
import {
  fbPixelCookieName,
  fbClickIdCookieName,
} from "services/shared/CookieNames";

export function useRecordReferredArticleEmailCapture(
  articlePageContext: ArticlePageContextValue
) {
  const recordReferredArticleEmailCapture = (
    email: string,
    subscriberId: string
  ) => {
    const {
      articleId,
      articleTitle,
      articleSlug,
      categoriesListForAnalytics,
      authorName,
      referrerEmail,
    } = articlePageContext;
    const articleUrl = `${baseUrl()}/${articleSlug}`;
    trackEvent(SegmentClientEvent.refereredArticleEmailCapture, {
      email,
      external_id: subscriberId,
      event_id: getSegmentEventIDForSubscriber(
        SegmentClientEvent.refereredArticleEmailCapture,
        subscriberId
      ),
      value: 0.0,
      currency: "USD",
      content_name: "sharedarticle",
      url: articleUrl,
      author: authorName,
      category: categoriesListForAnalytics,
      article_title: articleTitle,
      article_id: articleId,
      referral: true,
      referred_email: email,
      referrer_email: referrerEmail,
      fbp: Cookies.get(fbPixelCookieName),
      fbc: Cookies.get(fbClickIdCookieName),
    });
  };

  return recordReferredArticleEmailCapture;
}
